import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsKodiComponent } from './simple-icons-kodi.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsKodiComponent ],
    exports:      [ SimpleIconsKodiComponent ],
    bootstrap:    []
})
export class SimpleIconsKodiModule {}
